/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPCOMMSCHANNEL = {
    Post: 'CREATED',
    Fax: 'FAXCREATED',
    EMail: 'EMCREATED',
    Web: 'ECREATED',
    Phone: 'CREATEDCT',
    Other: 'OTHER'
} as const;
export type IAPCOMMSCHANNEL = typeof IAPCOMMSCHANNEL[keyof typeof IAPCOMMSCHANNEL];


export function IAPCOMMSCHANNELFromJSON(json: any): IAPCOMMSCHANNEL {
    return IAPCOMMSCHANNELFromJSONTyped(json, false);
}

export function IAPCOMMSCHANNELFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPCOMMSCHANNEL {
    return json as IAPCOMMSCHANNEL;
}

export function IAPCOMMSCHANNELToJSON(value?: IAPCOMMSCHANNEL | null): any {
    return value as any;
}

